const accordionHeaders = document.querySelectorAll('.accordion-header');

accordionHeaders.forEach(header => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling; 
    const isOpen = content.classList.contains('open');

    document.querySelectorAll('.accordion-content.open').forEach(openContent => {
      openContent.style.maxHeight = null;
      openContent.classList.remove('open');
      openContent.previousElementSibling.classList.remove('active');
    });

    if (!isOpen) {
      content.style.maxHeight = content.scrollHeight + 'px'; 
      content.classList.add('open');
      header.classList.add('active');
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {

const target = document.getElementById('product-details-cta');
const productFooter = document.getElementById('product-cart-footer');
const exploreCollection = document.getElementById('explore-collection');
const productHeader = document.getElementById('product-details-header');
const footer = document.getElementById('footer');


let isTargetVisible = false;
let isExploreVisible = false;
let isHeaderVisible = false;
let isFooterVisible = false;

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.target === target) {
        isTargetVisible = entry.isIntersecting;
      } else if (entry.target === exploreCollection) {
        isExploreVisible = entry.isIntersecting;
      } else if (entry.target === productHeader) {
        isHeaderVisible = entry.isIntersecting;
      } else if (entry.target === footer) {
        isFooterVisible = entry.isIntersecting;
      }

      if (!isTargetVisible && !isExploreVisible && !isHeaderVisible && !isFooterVisible) {
        productFooter.style.display = 'flex';
      } else {
        productFooter.style.display = 'none';
      }
    });
  },
  { threshold: 0.1 }
);


if(target && productHeader && exploreCollection && footer){
  observer.observe(target);
  observer.observe(productHeader);
  observer.observe(exploreCollection);
  observer.observe(footer)
}

})